import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { GlobalSettingsFormShape } from '../../../../components/smart-cart-form-global-settings/global-settings.model';
import { GoalFormShape, GoalsBarType, MinimumThresholdType } from '../../goals-progress-bar.model';

type GoalTab = 'threshold' | 'offer' | 'appearance';

// Thin shell: header (enable/remove/collapse) + tab switcher. Each tab's UI + logic lives in its own
// component (goal-threshold-tab / goal-offer-tab / goal-appearance-tab).
@Component({
  selector: 'smart-cart-goals-goal-card',
  templateUrl: './goal-card.component.html',
  styleUrls: ['../../../../components/shared.scss'],
  standalone: false,
})
export class SmartCartGoalsGoalCardComponent {
  @Input({ required: true }) goal!: FormGroup<GoalFormShape>;
  @Input({ required: true }) index!: number;
  @Input({ required: true }) minimumThresholdType!: FormControl<MinimumThresholdType>;
  @Input({ required: true }) barType!: FormControl<GoalsBarType>;
  @Input({ required: true }) pillsEnabled!: FormControl<boolean>;
  @Input({ required: true }) globalSettingsFormGroup!: FormGroup<GlobalSettingsFormShape>;
  @Input() thresholdErrors: Record<string, string> | null = null;
  @Input() isOnlyGoal = false;
  @Input() isAutoApplyBlockedByDisplayConditions = false;
  @Input() smartCartId: number | null = null;
  @Input() usageToken = '';

  @Output() remove = new EventEmitter<void>();

  activeTab: GoalTab = 'threshold';
  collapsed = false;

  setActiveTab(tab: GoalTab): void {
    this.activeTab = tab;
  }

  toggleCollapsed(): void {
    this.collapsed = !this.collapsed;
  }
}
